<script lang="ts" module>
  import type { Snippet } from 'svelte';

  import NoErrors from '../AssistantCard/NoErrors.svelte';

  export namespace AssistantDoneCard {
    export type Props =
      | {
          title: string;
          text: string;
          info?: Snippet;
        }
      | {
          title?: never;
          text?: never;
          info?: Snippet;
        };
  }
</script>

<script lang="ts">
  let { title, text, info }: AssistantDoneCard.Props = $props();
</script>

<div class="grid gap-3">
  {#if title && text}
    <NoErrors noErrorText={text} noErrorTitle={title}></NoErrors>
  {:else}
    <NoErrors noErrorText="Alles erledigt." noErrorTitle="Sehr gut!"></NoErrors>
  {/if}

  {@render info?.()}
</div>
